import { connect } from "react-redux";

import AttributeReady from "components/answer/AttributeReady";

import {
  setHeaderInfo,
  startEffect,
  finishEffect
} from "redux/modules/answer/answerHeader";
import { set as setSurveyLocale } from "redux/modules/answer/attributeReady";
import { set as setSurveyAttrs } from "redux/modules/answer/answerAttribute";
import { set as setQuestions } from "redux/modules/answer/answerQuestion";
import { setFreeCommentDescriptions } from "redux/modules/answer/answerOther";
import { openErrorDialog } from "redux/modules/errorDialog";

import history from "utils/history";
import storage from "utils/storage";
import api from "api";

const mapStateToProps = state => ({
  attributeReady: state.attributeReady,
  answerHeader: state.answerHeader,
  answerResult: state.answerResult
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("invalidOperation")));
  },
  fetchAttributeReady: (answerToken, localeId) => {
    const params = {
      surveyId: storage.getPreviewSurveyId(),
      localeId
    };

    api
      .get("attr_ready", params)
      .then(res => {
        dispatch(setHeaderInfo(res.headerInfo));
        dispatch(setSurveyLocale(res.surveyLocale));
        dispatch(setSurveyAttrs(res.surveyAttrs));
        dispatch(setQuestions(res.basicQuestions, res.additions));
        dispatch(setFreeCommentDescriptions(res.freeCommentDescriptions));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  handleNext: () => {
    dispatch(startEffect());

    setTimeout(() => {
      history.push("/answer_attribute", ownProps);

      dispatch(finishEffect());
    }, 300);
  },
  handleBack: () => {
    dispatch(startEffect());

    setTimeout(() => {
      ownProps.history.goBack();

      dispatch(finishEffect());
    }, 300);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AttributeReady);



// WEBPACK FOOTER //
// ./src/containers/preview/AttributeReadyContainer.js